var _defs, _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNewWhatsapp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "prefix__icons8-whatsapp",
    width: 22.446,
    height: 22.541,
    viewBox: "0 0 22.446 22.541",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .prefix__cls-1{fill:#fff}\n        "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_194",
    d: "M4.868 26.422l1.507-5.5a10.619 10.619 0 1 1 9.2 5.316 10.607 10.607 0 0 1-5.075-1.293z",
    className: "prefix__cls-1",
    "data-name": "Path 194",
    transform: "translate(-4.308 -4.441)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_195",
    d: "M4.648 26.481a.279.279 0 0 1-.27-.353l1.476-5.389a10.9 10.9 0 1 1 4.388 4.285l-5.523 1.448a.256.256 0 0 1-.071.009z",
    className: "prefix__cls-1",
    "data-name": "Path 195",
    transform: "translate(-4.088 -4.22)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_196",
    fill: "#cfd8dc",
    d: "M15.135 4.559a10.619 10.619 0 0 1 0 21.238 10.607 10.607 0 0 1-5.079-1.297l-5.629 1.481 1.507-5.5a10.62 10.62 0 0 1 9.2-15.921M15.134 3.998a11.181 11.181 0 0 0-9.8 16.555l-1.447 5.281a.559.559 0 0 0 .682.688L9.987 25.1A11.179 11.179 0 1 0 15.135 4z",
    "data-name": "Path 196",
    transform: "translate(-3.868 -4)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_197",
    fill: "#40c351",
    d: "M23.3 10.793a8.826 8.826 0 0 0-13.72 10.93l.21.334-.89 3.256 3.341-.876.323.191a8.809 8.809 0 0 0 4.492 1.23A8.826 8.826 0 0 0 23.3 10.793z",
    "data-name": "Path 197",
    transform: "translate(-5.791 -5.854)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_198",
    fill: "#fff",
    fillRule: "evenodd",
    d: "M17.107 15.679c-.2-.442-.408-.451-.6-.459-.155-.007-.332-.006-.508-.006a.975.975 0 0 0-.707.332 2.974 2.974 0 0 0-.929 2.212 5.159 5.159 0 0 0 1.085 2.742 10.894 10.894 0 0 0 4.532 4c2.241.884 2.7.708 3.184.664a2.678 2.678 0 0 0 1.791-1.261 2.222 2.222 0 0 0 .155-1.261c-.067-.111-.243-.177-.508-.31s-1.57-.775-1.813-.863-.42-.133-.6.133-.685.863-.84 1.04-.31.2-.575.067a7.262 7.262 0 0 1-2.131-1.309 7.994 7.994 0 0 1-1.476-1.837c-.155-.265-.017-.409.116-.541s.265-.31.4-.465a1.814 1.814 0 0 0 .265-.442.488.488 0 0 0-.022-.465c-.067-.135-.583-1.45-.819-1.971z",
    "data-name": "Path 198",
    transform: "translate(-8.494 -8.942)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewWhatsapp);
export default __webpack_public_path__ + "static/media/new_whatsapp.e01a1abce920036c7cc4d0ae4bb0491a.svg";
export { ForwardRef as ReactComponent };